import { createFileRoute } from '@tanstack/react-router';
import { BillingReadOnlyTab } from '@/components/settings/billing/BillingReadOnlyTab';

export const Route = createFileRoute('/_dashboard/dashboard/settings/billing/receipts')({
  component: () => <BillingReadOnlyTab tab="receipts" />,
});
